const V2Day1Part4StartingDialog = {
    startDialogId: 'part4_op1',
    nodes: {
        part4_op1: {
            id: 'part4_op1',
            speaker: 'Ato',
            text: `Ada apa ini!! Apa yang kalian telah perbuat!`,
            characterImage: '/assets/character/v2/ato.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op2',
        },
        part4_op2: {
            id: 'part4_op2',
            speaker: 'Elsa',
            text: `Tadi.. kami hanya...`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op3',
        },
        part4_op3: {
            id: 'part4_op2',
            speaker: 'Holga',
            text: `Minggir!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op4',
        },
        part4_op4: {
            id: 'part4_op2',
            speaker: 'Holga',
            text: `Ya ampun apa yang terjadi ini anak saya!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op5',
        },
        part4_op5: {
            id: 'part4_op2',
            speaker: 'Holga',
            text: `Apa yang telah kau perbuat dik!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op6',
        },
        part4_op6: {
            id: 'part4_op2',
            speaker: 'Elsa',
            text: `Saat saya temukan kondisinya sudah seperti ini.`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op7',
        },
        part4_op7: {
            id: 'part4_op2',
            speaker: 'Holga',
            text: `Jangan bohong kamu!! Pasti ulah kamu!!`,
            characterImage: '/assets/character/v2/holga.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op8',
        },
        part4_op8: {
            id: 'part4_op2',
            speaker: 'Ato',
            text: `Oh ternyata kamu biangnya? Sini kamu!`,
            characterImage: '/assets/character/v2/ato.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op9',
        },
        part4_op9: {
            id: 'part4_op2',
            speaker: 'Romo Darius',
            text: `Ato, Holga! Harap tenang!`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op10',
        },
        part4_op10: {
            id: 'part4_op2',
            speaker: 'Romo Darius',
            text: `Sebaiknya kita jangan gegabah. Gadis muda, bisa dijelaskan apa yang terjadi?`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op11',
        },
        part4_op11: {
            id: 'part4_op10',
            speaker: 'Elsa',
            text: `Saya dan Diana sedang berjalan kembali ke arah kota.`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op12',
        },
        part4_op12: {
            id: 'part4_op11',
            speaker: 'Elsa',
            text: `Kami hanya menemukan mayat gadis ini saja, karena panik saya langsung lari meminta pertolongan.`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op13',
        },
        part4_op13: {
            id: 'part4_op2',
            speaker: 'Romo Darius',
            text: `Apakah kalian melihat sesuatu setelah atau sebelum kejadian ini? `,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op14',
        },
        part4_op14: {
            id: 'part4_op11',
            speaker: 'Elsa',
            text: `Tidak ada...`,
            characterImage: '/assets/character/v2/elsa.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op15',
        },
        part4_op15: {
            id: 'part4_op11',
            speaker: 'Diana',
            text: `Maaf romo, aku tidak kepikiran apa-apa.`,
            characterImage: '/assets/character/v2/diana.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op16',
        },
        part4_op16: {
            id: 'part4_op2',
            speaker: 'Romo Darius',
            text: `Baiklah, kalian harap tenang juga `,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/danau.png',
            nextDialogId: 'part4_op17',
        },
        part4_op17: {
            id: 'part4_op2',
            speaker: 'Romo Darius',
            text: `Ato, panggil-lah orang-orang lain, kita harus bergegas memindahkan mayat ke kota.`,
            characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/danau.png',
            isEnd : true
        },
    },
}

export default V2Day1Part4StartingDialog